import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantUserRoot = () => {
  useProtected();

  return <Outlet />;
};

export { UsersPage } from "./Users";
export { UserPage } from "./User";
